module.exports = __webpack_public_path__ + "static/media/spinner.5fe0e55f.gif";